<template>
    <section v-if="mail.detail && (mail.detail.id || mail.detail.externalJobId)">
        <button
            v-if="this.$route.params && this.$route.params.client"
            @click="disputeLetterStore.display = 1;"
            class="btn mt-2 mb-2 btn-success"
        >
            Back
        </button>
        <button v-else @click="$router.go(-1)" class="btn mt-2 mb-2 btn-success">
            Back
        </button>
        <template v-if="lobSettingStore.quadient == mail.type">
            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header">
                            <h1 class="text-center">Recipient</h1>
                        </div>
                        <div class="card-body text-left">
                            <p class="mb-0">{{ mail.detail.recipients[0].name }}</p>
                            <p class="mb-0">{{ mail.tracking.postalDetail.recipient.addressLines[0] }}</p>
                            <p class="mb-0">
                                {{ mail.tracking.postalDetail.recipient.addressLines[1] }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card text-center mb-3">
                        <div class="card-header">
                            <h1 class="text-center">Sender</h1>
                        </div>
                        <div class="card-body text-left">
                            <p class="mb-0">
                                {{ getUserDetail("First Name") }} {{ getUserDetail("Last Name") }}
                            </p>
                            <p class="mb-0">{{ getUserDetail("Address") }}</p>
                            <p class="mb-0">
                                {{ getUserDetail("City") }},
                                {{ getUserDetail("State") }} {{ getUserDetail("Postcode") }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row match-height">
                <div class="col-12 col-md-12 col-lg-12">
                    <div class="card">
                        <div class="card-body text-center">
                            <div class="text-center">
                                <div class="text-success mt-1 mb-1">
                                    {{ mail.detail.letter.emailService }}
                                </div>
                                <h1 class="mb-2 mt-2">
                                    Letter to {{ mail.detail.recipients[0].name }} from {{ getUserDetail("First Name") }} {{ getUserDetail("Last Name") }}
                                </h1>
                                <a :href="mail.url" target="_blank" class="btn text-success border-success">View Letter</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 mt-5 mb-5 col-md-12 col-12">
                    <div class="card card-profile">
                        <div class="card-body">
                            <div class="profile-image-wrapper">
                                <div class="profile-image">
                                    <div class="avatar">
                                        <img :src="settingStore.logo" alt="Profile Picture" />
                                    </div>
                                </div>
                            </div>
                            <div class="row match-height">
                                <div class="col-12 col-md-6 col-lg-6">
                                    <div class="card-header">
                                        <h1>{{ localizationStore.translate("lob.letter.details") }}</h1>
                                    </div>
                                    <div class="text-left card-body pl-2">
                                        <p v-if="mail.detail.letter" class="mb-0">Letter Name: {{ mail.detail.letter.name || '' }}</p>
                                        <p v-if="mail.detail.letter" class="mb-0">Number Of Pages: {{ mail.detail.letter.number_of_pages || '' }}</p>
                                        <p class="mb-0">Color: {{ mail.detail.deliveryConfiguration.useColorPrinting == true ? 'Color' : 'Black and White' }}</p>
                                        <p class="mb-0">Envelope Size: {{ mail.detail.letter.envelopSize }}</p>
                                        <p class="mb-0">Double Sided: {{ mail.detail.deliveryConfiguration.useBothSidePrinting == true ? 'Yes' : 'No' }}</p>
                                        <p class="mb-0">Service: {{ mail.detail.letter.emailService }}</p>
                                        <p v-if="mail.tracking?.postalDetail?.subServiceInfos?.length > 0" class="mb-0">
                                            Delivery Tracking:
                                            <span class="ml-50 badge badge-primary">
                                                {{ getDeliveryTracking() }}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6">
                                    <div class="card-header mx-auto">
                                        <h1>{{ localizationStore.translate("lob.letter.tracking.status") }}</h1>
                                    </div>
                                    <ul class="timeline mx-auto" v-if="mail.tracking?.postalDetail?.deliveryStatuses?.length > 0">
                                        <li v-for="tracking in mail.tracking?.postalDetail?.deliveryStatuses" class="timeline-item">
                                            <span class="timeline-point timeline-point-indicator"></span>
                                            <div class="timeline-event">
                                                <div class="d-flex align-items-center flex-sm-row flex-column mb-sm-0 mb-1">
                                                    <h6 class="mb-0">{{ tracking.status }}</h6>
                                                    <span v-if="tracking.trackingCode" class="ml-50 badge badge-primary">
                                                        {{ tracking.trackingCode }}
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <h6 v-else class="mt-1 mb-1 float-right">{{ localizationStore.translate("lob.tracking.status") }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header">
                            <h1 class="text-center">Recipient</h1>
                        </div>
                        <div class="card-body text-left">
                            <p class="mb-0">{{ mail.detail.recipients[0].firstName }}</p>
                            <p class="mb-0">{{ mail.detail.recipients[0].postalAddress.address1 }}</p>
                            <p class="mb-0">
                                {{ mail.detail.recipients[0].postalAddress.city }},
                                {{ mail.detail.recipients[0].postalAddress.state }} {{ mail.detail.recipients[0].postalAddress.postcode }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card text-center mb-3">
                        <div class="card-header">
                            <h1 class="text-center">Sender</h1>
                        </div>
                        <div class="card-body text-left">
                            <p class="mb-0">
                                {{ mail.detail.sender.firstName }} {{ mail.detail.sender.lastName }}
                            </p>
                            <p class="mb-0">{{ mail.detail.sender.postalAddress.address1 }}</p>
                            <p class="mb-0">
                                {{ mail.detail.sender.postalAddress.city }},
                                {{ mail.detail.sender.postalAddress.state }} {{ mail.detail.sender.postalAddress.postcode }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row match-height">
                <div class="col-12 col-md-12 col-lg-12">
                    <div class="card">
                        <div class="card-body text-center">
                            <div class="text-center">
                                <div class="text-success mt-1 mb-1">
                                    {{ mail.detail.delivery.emailService }}
                                </div>
                                <h1 class="mb-2 mt-2">
                                    Letter to {{ mail.detail.recipients[0].firstName }} from {{ mail.detail.sender.firstName }} {{ mail.detail.sender.lastName }}
                                </h1>
                                <a :href="mail.url" target="_blank" class="btn text-success border-success">View Letter</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 mt-5 mb-5 col-md-12 col-12">
                    <div class="card card-profile">
                        <div class="card-body">
                            <div class="profile-image-wrapper">
                                <div class="profile-image">
                                    <div class="avatar">
                                        <img :src="settingStore.logo" alt="Profile Picture" />
                                    </div>
                                </div>
                            </div>
                            <div class="row match-height">
                                <div class="col-12 col-md-6 col-lg-6">
                                    <div class="card-header">
                                        <h1>{{ localizationStore.translate("lob.letter.details") }}</h1>
                                    </div>
                                    <div class="text-left card-body pl-2">
                                        <p v-if="mail.detail.letter" class="mb-0">Letter Name: {{ mail.detail.letter.name || '' }}</p>
                                        <p v-if="mail.detail.letter" class="mb-0">Number Of Pages: {{ mail.detail.letter.number_of_pages || '' }}</p>
                                        <p class="mb-0">Color: {{ mail.detail.printing.printColor }}</p>
                                        <p class="mb-0">Envelope Size: {{ mail.detail.printing.envelopSize }}</p>
                                        <p class="mb-0">Double Sided: {{ mail.detail.printing.duplex == true ? 'Yes' : 'No' }}</p>
                                        <p class="mb-0">Service: {{ mail.detail.delivery.emailService }}</p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6">
                                    <div class="card-header mx-auto">
                                        <h1>{{ localizationStore.translate("lob.letter.tracking.status") }}</h1>
                                    </div>
                                    <ul class="timeline mx-auto" v-if="mail.tracking.length > 0">
                                        <li v-for="tracking in mail.tracking" class="timeline-item">
                                            <span class="timeline-point timeline-point-indicator"></span>
                                            <div class="timeline-event">
                                                <div class="d-flex align-items-center flex-sm-row flex-column mb-sm-0 mb-1">
                                                    <h6 class="mb-0">{{ tracking.status }}</h6>
                                                    <span v-if="tracking.trackingCode" class="ml-50 badge badge-primary">
                                                        {{ tracking.trackingCode }}
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <h6 v-else class="mt-1 mb-1 float-right">{{ localizationStore.translate("lob.tracking.status") }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </section>
    <loading v-else />
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import moment from 'moment';
    import { useDisputeLetterStore } from '../../stores/DisputeLetterStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js';
    import { useSettingStore } from '../../stores/SettingStore.js';
    import { useLobSettingStore } from '../../stores/LobSettingStore.js';
    import Loader from '../report/Loader'
    import Swal from 'sweetalert2'
    export default {
        components: {
            'loading': Loader,
        },
        setup(props) {
            return {
                mail: reactive({}),
                moment: moment,
                disputeLetterStore: useDisputeLetterStore(),
                localizationStore: useLocalizationStore(),
                settingStore: useSettingStore(),
                lobSettingStore: useLobSettingStore(),
            }
        },
        mounted() {
            this.getMail();
        },
        watch: {
        },
        methods: {
            getMail()
            {
                let $this = this;
                const route = this.$router.resolve(
                    {
                        name: 'mail-show',
                        params: {
                            mail: ($this.$route.params && $this.$route.params.client) ? $this.disputeLetterStore.mail_id : $this.$route.params.mail,
                            client: $this.$route.params.client,
                            team: $this.$route.params.team
                        }
                    }
                );
                axios.get(route.href).then(function(response) {
                    if(response.data.error == true) {
                        if ($this.$route.params?.client) {
                            $this.disputeLetterStore.display = 1;
                        }
                        else {
                            $this.$router.go(-1);
                        }
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    Object.assign($this.mail, response.data.data);
                    return;
                }).catch(function(error) {
                    setTimeout(() => {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    }, 2000)
                });
            },
            getUserDetail(key) {
                let userAttribute = _.find(
                    this.mail.tracking.postalDetail.attributes.userAttributes,
                    function(user) { return user.key == key; }
                );
                return userAttribute.value;
            },
            getDeliveryTracking() {
                if (this.mail.tracking?.postalDetail?.subServiceInfos) {
                    let deliveryTracking = _.find(this.mail.tracking.postalDetail.subServiceInfos,
                        function(subServiceInfo) {
                            return subServiceInfo.identifier == "DeliveryTracking";
                        }
                    );
                    return deliveryTracking?.stringValue || '';
                }
                return '';
            }
        }
    }
</script>